import { InputMask } from './';
import { padStart as lo_padStart } from 'es-toolkit/compat';
import { trimStart as lo_trimStart } from 'es-toolkit/compat';

// TODO: Allow for more formats in the future
// TODO: Only handles US format for now
const phoneFormattedUs = '+0 (000) 000-0000';
const phoneRawUs = '+00000000000';

export function formatPhone(
    phone: string,
    format: string = 'formatted',
    countryCode: string = 'US'
): string {
    phone = lo_trimStart(phone, '+');

    if (phone.length <= 10) {
        phone = lo_padStart(phone ?? '', 11, '1')
    }

    if (format === 'raw') {
        return InputMask.apply(phone, phoneRawUs);
    } else {
        return InputMask.apply(phone, phoneFormattedUs);
    }
}
